const LANGUAGES_CODES = {
  en: 0,
  ru: 1,
  zh: 2,
  es: 3,
  et: 4,
  tr: 5,
};

const LANGUAGES_LIST = [
  {
    id: LANGUAGES_CODES.en,
    caption: 'English',
    code: 'EN',
  },
  {
    id: LANGUAGES_CODES.ru,
    caption: 'Russian',
    code: 'RU',
  },
  {
    id: LANGUAGES_CODES.zh,
    caption: 'Chinese',
    code: 'ZH',
  },
  {
    id: LANGUAGES_CODES.es,
    caption: 'Spanish',
    code: 'ES',
  },
  {
    id: LANGUAGES_CODES.et,
    caption: 'Estonian',
    code: 'ET',
  },
  {
    id: LANGUAGES_CODES.tr,
    caption: 'Turkish',
    code: 'TR',
  },
];

export default {
  LANGUAGES_LIST,
  LANGUAGES_CODES,
};
